import '../application';
import 'sbf-design-system-component/forms/base';

$(() => {
  const INTERNATIONAL_COUNTRIES_OPTION = 'INTL';
  const $country = $('#country');
  const $city = $('#city_container');
  const $state = $('#state_container');
  const $searchForm = $('#search-form');

  const shouldShowFields = () => $country.val() !== '' && $country.val() !== INTERNATIONAL_COUNTRIES_OPTION;

  const toggleFieldsVisibility = () => {
    const shouldShow = shouldShowFields();
    $city.toggle(shouldShow);
    $state.toggle(shouldShow);
  };

  $country.change(toggleFieldsVisibility).change();

  $searchForm.submit(() => {
    if (!shouldShowFields()) {
      $('#search-form #state_container, #search-form #city_container').remove();
    }
    return true;
  });
});
